/** @file The document's direction set as a draft; VALIDATION when the project has none yet. */
import type { Draft } from 'immer';
import type { DirectionsDoc, Doc } from '@pose2d/format/types';
import { throwError } from '@pose2d/format/throwError';

/** `draft.directions`, or VALIDATION at `path` telling the caller to run direction.setCount first. */
export function directionsDraft(draft: Draft<Doc>, path: string): Draft<DirectionsDoc> {
  return draft.directions ?? throwError('VALIDATION', undefined, { path, hint: 'the project has no direction set; run direction.setCount first' });
}
